module.exports = __webpack_public_path__ + "static/media/OBCB01.36269953.jpg";